const defaultState = {
  categories: [],
  products: [],
  layouts: [],
};

export default {
  namespaced: true,
  state: defaultState,
  mutations: {
    set (state, { key, value }) {
      state[key] = value;
    },
    init (state) {
      Object.assign(state, defaultState);
    },
  },
};
